import { useEffect, useState } from "react";
import { toast } from "sonner";
import api from "../../lib/api";
import { JubelioPicker, ProductLine } from "./JubelioPicker";
import { inp, toastErr } from "./util";

export default function SupplierMappings() {
    const [q, setQ] = useState("");
    const [rows, setRows] = useState(null);
    const [edit, setEdit] = useState(null);
    const load = () => api.get("/invoices/mappings", { params: { q } }).then(({ data }) => setRows(data)).catch((e) => toastErr(e, "Failed to load mappings"));
    useEffect(() => {
        const t = setTimeout(load, 250);
        return () => clearTimeout(t);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [q]);
    const change = async (p) => {
        try { await api.put(`/invoices/mappings/${edit.id}`, { item_id: p.item_id, item_code: p.item_code, name: p.name, thumbnail: p.thumbnail }); toast.success("Mapping updated"); load(); } catch (e) { toastErr(e); }
    };
    const unlink = async (m) => {
        if (!window.confirm(`Lepas mapping ${m.supplier_name} · ${m.supplier_sku}? Invoice yang sudah tersimpan tidak berubah.`)) return;
        try { await api.delete(`/invoices/mappings/${m.id}`); load(); } catch (e) { toastErr(e); }
    };
    return (
        <div className="space-y-3" data-testid="supplier-mappings">
            <p className="text-xs text-neutral-500">Supplier SKU ≠ Jubelio SKU. Beberapa Supplier SKU boleh terhubung ke satu produk Jubelio. Mapping tersimpan saat Owner mengonfirmasi produk di invoice.</p>
            <input className={inp} placeholder="Supplier, supplier SKU, Jubelio SKU or product" value={q} onChange={(e) => setQ(e.target.value)} data-testid="mapping-search" />
            {rows && rows.length === 0 && <p className="text-sm text-neutral-400">No mappings yet.</p>}
            {(rows || []).map((m) => (
                <div key={m.id} className="border border-mist rounded-sm bg-white p-3 space-y-1" data-testid={`mapping-${m.id}`}>
                    <div className="text-xs"><b>{m.supplier_name}</b> · <span className="font-mono font-semibold">{m.supplier_sku}</span> →</div>
                    <ProductLine p={{ name: m.product_name, item_code: m.jubelio_item_code, thumbnail: m.thumbnail, catalog_image: m.catalog_image }} testid={`mapping-product-${m.id}`} />
                    <div className="text-[11px] text-neutral-400">Confirmed by {m.confirmed_by} · {new Date(m.updated_at).toLocaleString("id-ID")}</div>
                    <div className="flex gap-3 text-xs">
                        <button type="button" className="underline" onClick={() => setEdit(m)} data-testid={`mapping-change-${m.id}`}>Ganti produk</button>
                        <button type="button" className="underline text-rose-700" onClick={() => unlink(m)} data-testid={`mapping-unlink-${m.id}`}>Lepas mapping</button>
                    </div>
                </div>
            ))}
            <JubelioPicker open={!!edit} key={edit?.id} initial={edit?.product_name || ""} onClose={() => setEdit(null)} onPick={change} />
        </div>
    );
}
